import type { ShopForVehicle, ShopForVehicleSet } from "@spare-cart/contracts/vehicles";
import { apiClient } from "@core/api";
import type { ShopForVehicleSelection } from "./useShopForVehicle";

export const fetchShopForVehicle = (): Promise<ShopForVehicle | null> =>
  apiClient.get<ShopForVehicle | null>("/shop-for-vehicle");

export const pushShopForVehicle = (selection: ShopForVehicleSelection): Promise<ShopForVehicle> => {
  const body: ShopForVehicleSet = {
    vehicleTypeId: selection.vehicleTypeId,
    makeId: selection.makeId,
    modelId: selection.modelId,
    variantId: selection.variantId,
    year: selection.year,
    userVehicleId: selection.userVehicleId,
  };
  return apiClient.put<ShopForVehicle>("/shop-for-vehicle", body);
};

export const deleteShopForVehicle = (): Promise<void> =>
  apiClient.remove<void>("/shop-for-vehicle");

export const toShopForVehicleSelectionFromApi = (row: ShopForVehicle): ShopForVehicleSelection => ({
  id: row.id,
  title: row.title,
  subtitle: row.subtitle,
  vehicleTypeId: row.vehicleTypeId,
  makeId: row.makeId,
  modelId: row.modelId,
  variantId: row.variantId,
  year: row.year,
  userVehicleId: row.userVehicleId,
});
